// Format a tour's numeric tour_number as a human-readable display ID.
// Returns 'Pending' for tours not yet submitted (tour_number is null).
export function formatTourId(num) {
  if (num === null || num === undefined || num === '') return 'Pending';
  return 'T-' + String(num).padStart(6, '0');
}
